import DesImageViewerViewModel from 'viewmodel/DesImageViewerViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesImageViewer extends DesBaseCatalogAcc {
    constructor() {
        super(DesImageViewerViewModel);
    }

    get src() {
        return this.getAttribute('src');
    }

    getProps() {
        return {
            src: this.src,
            provider: this.provider,
            catalogspaceid: this.catalogspaceId,
            locale: this.locale
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'src'];
    }
}

if (!window.customElements.get('des-image-viewer')) {
    window.customElements.define('des-image-viewer', DesImageViewer);
}
